import { AdminRoleUsersDirectory } from "@/features/admin/components/AdminRoleUsersDirectory";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/users/patients")({
    component: PatientsUsersPage,
});

function PatientsUsersPage() {
    return (
        <>
            <AdminRoleUsersDirectory role="PATIENT" emptyLabel="patients" />
            <Outlet />
        </>
    );
}
